import React from "react";

import { Text } from "web/react/emo/text";

import LazyImage from "web/react/components/lazy-load-image/lazy-load-image";
import { ResponsiveTextStyle } from "web/react/emo/sprinkles.css";
import * as styles from "./image-container.css";

interface ImageContainerProps {
    imageSrc: string;
    imageCredit?: string | null;
    alt?: string;
    width?: number | string;
    height?: number;
    imageClassName?: string;
    textStyle?: ResponsiveTextStyle;
    isLazy?: boolean;
}

export function ImageContainer({
    imageSrc,
    imageCredit,
    alt,
    width,
    height,
    imageClassName,
    textStyle = "caption-3",
    isLazy = false,
}: ImageContainerProps): React.ReactElement {
    return (
        <div className={styles.imageContainer}>
            {isLazy ? (
                <LazyImage
                    dataTestId="introimage"
                    className={imageClassName ?? styles.image}
                    width={width}
                    height={height}
                    src={imageSrc}
                    alt={alt}
                />
            ) : (
                <img
                    data-testid="introimage"
                    className={imageClassName ?? styles.image}
                    width={width}
                    height={height}
                    src={imageSrc}
                    alt={alt}
                />
            )}
            {imageCredit && (
                <Text className={styles.imageCredit} textStyle={textStyle} upperCase>
                    {imageCredit}
                </Text>
            )}
        </div>
    );
}
